import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

/**
 * 채팅 사용자 차단 Repository — wiz-chat 의 /api/chat/blocks 와 1:1 매핑.
 */
export class BlockRepository {
    /** 사용자 차단 */
    static onPostBlock = (blockedUserNo: number, reason?: string) => {
        return onRequest({
            url: getApiUrl('chatBlocks'),
            method: RequestMethod.POST,
            params: { blockedUserNo, reason: reason ?? null }
        })
    }

    /** 차단 해제 */
    static onDeleteBlock = (blockedUserNo: number) => {
        return onRequest({
            url: `${getApiUrl('chatBlocks')}/${blockedUserNo}`,
            method: RequestMethod.DELETE,
        })
    }

    /** 내가 차단한 사용자 목록 */
    static onGetMyBlocks = () => {
        return onRequest({
            url: getApiUrl('chatBlocks'),
            method: RequestMethod.GET,
        })
    }
}
